import { Injectable } from '@angular/core';

/**
 * Configuration service, provides default values for the AccordionComponent.
 */
@Injectable()
export class AccordionConfig {
  /** Whether the other panels should be closed when a panel is opened */
  public closeOthers: Boolean = false;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./~/ng2-bootstrap/src/accordion/accordion.config.ts